var cibAnalogue = ["32 32", "<path d='M7.292 17.073c-9.131-0.573-9.989 13.12-0.86 13.692 9.131 0.573 9.989-13.12 0.86-13.692zM31.079 20.489l-9.147-15.844c-4.577-7.921-16.459-1.057-11.88 6.865l9.145 15.839c1.896 3.281 6.095 4.405 9.376 2.515 3.281-1.895 4.405-6.093 2.505-9.375z'/>"];

export { cibAnalogue };

